import { Form, Select, Space, Row, Col } from 'antd';
import { FunctionComponent } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { YoutubeCategories, YoutubeCategoryLabels } from '@monorepo/types';
import { useTranslation } from 'react-i18next';
import { FormSelectTags } from '@monorepo/react-components';

interface SeriesOptionsFormProps {
  form: UseFormReturn<any>;
}

export const SeriesOptionsForm: FunctionComponent<SeriesOptionsFormProps> = ({
  form,
}) => {
  const { t } = useTranslation();
  const youtubeCategoryId =
    form.watch('settings.youtubeCategoryId') || YoutubeCategories.Entertainment;

  return (
    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12}>
          <Form.Item
            label={t('seriesForm.settings.youtubeCategory')}
            tooltip={{
              title: t('seriesForm.settings.youtubeCategoryTooltip'),
              placement: 'right',
              overlayStyle: { maxWidth: 300 },
              color: '#1677ff',
            }}
            style={{ marginBottom: 0 }}
          >
            <Select
              value={youtubeCategoryId}
              onChange={(value) => {
                form.setValue('settings.youtubeCategoryId', value, {
                  shouldValidate: true,
                });
              }}
              options={Object.entries(YoutubeCategoryLabels).map(
                ([key, label]) => ({
                  value: key,
                  label: t(`seriesForm.youtubeCategory.${key}`, {
                    defaultValue: label,
                  }),
                })
              )}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col xs={24}>
          <Form.Item
            label={t('seriesForm.settings.hashtags')}
            tooltip={{
              title: t('seriesForm.settings.hashtagsTooltip'),
              placement: 'right',
              overlayStyle: { maxWidth: 300 },
              color: '#1677ff',
            }}
            style={{ marginBottom: 0 }}
          >
            <FormSelectTags
              form={form}
              controllerProps={{ name: 'hashtags' }}
              options={(form.watch('hashtags') || []).map((tag: string) => ({
                value: tag,
                label: tag,
              }))}
            />
          </Form.Item>
        </Col>
      </Row>
    </Space>
  );
};
